import {
  Dialog,
  DialogHeader,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import BasicSelect from "../UI/Select/BasicSelect";
import { ContactsSelectModal } from "./ReusableContactsDisplay";
import { UserPlusIcon } from "@heroicons/react/24/solid";
import { useUserStore, useWorkspaceStore } from "../../Context/store";
import { useEffect, useMemo, useState } from "react";
import { useGetExistingUsers } from "../../Web-Hooks/Debate/use-users";
import { useSubWorkspacesByWorkspaceId } from "../../Web-Hooks/Workspace/use-subworkspace";
import { useLocation } from "react-router-dom";

const ExistingMembers = ({ contacts, setContacts, limit }) => {
  const { user: loggedInUser } = useUserStore();
  const { selectedWorkspace, workspaceList } = useWorkspaceStore();
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(null);
  const { pathname } = useLocation();
  const [displayContacts, setDisplayContacts] = useState([]);

  const isForumOnly = !pathname.includes("createprofile");

  const { data: existingUserList, isLoading } = useGetExistingUsers({
    workspaceId: filter?.workspace?.value || selectedWorkspace?.workSpaceId,
    subworkspaceId: filter?.forum?.value || "",
  });

  const { data: subworkspaceList, isLoading: isForumsLoading } =
    useSubWorkspacesByWorkspaceId(
      filter?.workspace?.value || selectedWorkspace?.workSpaceId,
      loggedInUser?.userId
    );

  const forums = useMemo(
    () =>
      subworkspaceList?.map((item) => ({
        id: item?.subWorkSpaceId,
        label: item?.subWorkSpaceName,
        value: item?.subWorkSpaceId,
      })) || [],
    [subworkspaceList]
  );

  const forumOptions = [
    {
      id: "all-forum",
      label: "All Forum",
      value: "",
    },
    ...forums,
  ];
  const workspaceOptions = useMemo(
    () =>
      workspaceList?.map((item) => ({
        id: item?.workSpaceId,
        label: item?.workSpaceName,
        value: item?.workSpaceId,
      })) || [],
    [workspaceList]
  );

  const handleClick = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(null);
  };
  const handleConfirm = (selected) => {
    setContacts(selected);
    setOpen(false);
  };

  useEffect(() => {
    if (contacts?.length > 0) {
      const filteredContacts = existingUserList?.filter((contact) => {
        return !contacts?.some((selectedContact) => {
          return (
            selectedContact?.value?.toLowerCase() ===
            contact?.value?.toLowerCase()
          );
        });
      });
      setDisplayContacts(filteredContacts);
    }else{
      setDisplayContacts(existingUserList);
    }
  }, [existingUserList, contacts]);

  return (
    <>
      <IconButton variant="text" id={"Add-from-existing"} onClick={handleClick}>
        <Tooltip className="z-10000000" content="Add Existing Contacts">
          <UserPlusIcon className="h-6 w-6 text-secondary" />
        </Tooltip>
      </IconButton>
      <Dialog
        open={open}
        handler={handleClose}
        size="md"
        dismiss={{
          outsidePress: false,
        }}
      >
        <DialogHeader>Select Contacts</DialogHeader>
        <div className="flex gap-3 justify-content-end px-4">
          <BasicSelect
            id="workspace"
            Options={workspaceOptions}
            value={
              filter?.workspace || {
                label: selectedWorkspace?.workSpaceName,
                value: selectedWorkspace?.workSpaceId,
              }
            }
            disabled={isForumOnly ? true : false}
            onChange={(value) => {
              setFilter({
                workspace: value,
                forum: { label: "All Forum", value: "" },
              });
            }}
          />
          <BasicSelect
            id="forum"
            Options={forumOptions}
            value={
              filter?.forum || {
                label: "All Forum",
                value: "",
              }
            }
            onChange={(value) => {
              setFilter({ ...filter, forum: value });
            }}
            loading={isForumsLoading}
          />
        </div>
        <ContactsSelectModal
          open={open}
          onClose={handleClose}
          contacts={displayContacts}
          // limit={limit}
          onConfirm={handleConfirm}
          selectedContacts={contacts}
          loading={isLoading}
        />
      </Dialog>
    </>
  );
};

export default ExistingMembers;
